import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            { key: 'name', trans: 'name', defaultOperator: 'like' },
            {
                key: 'serialNumber',
                trans: 'serialNumber',
                defaultOperator: 'like',
            },
        ],
        type: 'input',
        value: [],
    },
    {
        key: [
            { key: 'createdDate', trans: 'createdDate', defaultOperator: '=' },
            {
                key: 'installationDate',
                trans: 'installationDate',
                defaultOperator: '=',
            },
        ],
        type: 'date',
        value: [],
    },
];
